import config from "@/config";
import * as FullStory from "@fullstory/browser";

export enum FullstoryEvent {
  ApplicationChanged = "Application changed",
  EmailConfirmed = "Email confirmed with magic link",
  FeedbackSubmitted = "Feedback submitted",
  MagicLinkResent = "Magic link resent",
  UnandledErrorThrown = "Unhandled error thrown",
}

export interface EventData {
  description?: string;
  [key: string]: unknown;
}

export const useFullstory = () => {
  const init = () => {
    FullStory.init({
      devMode: !config.apiBaseUrl.startsWith("https://api.lendflow.com"),
      orgId: config.fsOrgId,
      recordCrossDomainIFrames: config.isIframed,
      recordOnlyThisIFrame: !config.isIframed,
    });
  };

  const publishEvent = <Data extends EventData>(event: FullstoryEvent, data: Data) => {
    if (!FullStory.isInitialized()) {
      init();
    }
    FullStory.event(event, data);
  };

  const identify = (id: string, data?: Record<string, unknown>) => {
    if (!FullStory.isInitialized()) {
      init();
    }
    FullStory.identify(id, data);
  };

  const anonymize = () => {
    if (!FullStory.isInitialized()) {
      return;
    }
    FullStory.anonymize();
  };

  return { init, identify, publishEvent, anonymize };
};
